import { useQuery } from '@tanstack/react-query'
import knowledgeApi from '@/lib/knowledge-api'
import { format, subDays } from 'date-fns'

interface InteractionsChartData {
  labels: string[]
  data: number[]
}

interface TokensChartData {
  labels: string[]
  input_tokens: number[]
  output_tokens: number[]
}

export function useInteractionsChart(days: number = 30) {
  const endDate = new Date()
  const startDate = subDays(endDate, days)
  
  return useQuery({
    queryKey: ['interactions-chart', days],
    queryFn: async () => {
      const response = await knowledgeApi.get('/knowledge/api/interactions/', {
        params: {
          start_date: format(startDate, 'yyyy-MM-dd'),
          end_date: format(endDate, 'yyyy-MM-dd'),
        },
      })
      return response.data as InteractionsChartData
    },
  })
}

export function useTokensChart(days: number = 30) {
  const endDate = new Date()
  const startDate = subDays(endDate, days)
  
  return useQuery({
    queryKey: ['tokens-chart', days],
    queryFn: async () => {
      const response = await knowledgeApi.get('/knowledge/api/tokens/', {
        params: {
          start_date: format(startDate, 'yyyy-MM-dd'),
          end_date: format(endDate, 'yyyy-MM-dd'),
        },
      })
      return response.data as TokensChartData
    },
  })
}
